/**
 * relativeTime — Converts a date to a human-readable relative timestamp.
 *
 * < 1 hour  → "Just now"
 * < 24 hrs  → "5h ago"
 * < 7 days  → "3d ago"
 * < 30 days → "2w ago"
 * ≥ 30 days → "Feb 17" (absolute)
 */
export function relativeTime(dateInput: Date | string | number): string {
  const now = Date.now();
  const date = new Date(dateInput).getTime();
  const diffMs = now - date;
  const diffMin = Math.floor(diffMs / 60000);
  const diffHr = Math.floor(diffMs / 3600000);
  const diffDay = Math.floor(diffMs / 86400000);
  const diffWeek = Math.floor(diffDay / 7);

  if (diffMin < 60) return 'Just now';
  if (diffHr < 24) return `${diffHr}h ago`;
  if (diffDay < 7) return `${diffDay}d ago`;
  if (diffDay < 30) return `${diffWeek}w ago`;
  return new Date(date).toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
}
